export default __webpack_public_path__ + "static/media/sumAssured.00dfacd1.png";